<template>
  <in-layout>
    <v-stepper vertical slot="content" v-model="stepValue">

      <v-stepper-step :step="1" editable :complete="validSteps[0]">
        Solicitante
      </v-stepper-step>
      <v-stepper-content step="1">
        <entity-step/>
      </v-stepper-content>

      <v-stepper-step :step="2" :editable="editableStep(2)" :complete="validSteps[1]">
        Endereço de Correspondência
      </v-stepper-step>
      <v-stepper-content step="2">
        <mailing-address/>
      </v-stepper-content>

      <v-stepper-step :step="3" :editable="editableStep(3)" :complete="validSteps[2]">
        Forma de Licenciamento
      </v-stepper-step>
      <v-stepper-content step="3">
        <application-way/>
      </v-stepper-content>

      <v-stepper-step :step="4" :editable="editableStep(4)" :complete="validSteps[3]">
        Enquadramento
      </v-stepper-step>
      <v-stepper-content step="4">
        <framework-step/>
      </v-stepper-content>

      <v-stepper-step :step="5" :editable="editableStep(5)" :complete="validSteps[4]">
        Pedido
      </v-stepper-step>
      <v-stepper-content step="5">
        <application-type-step/>
      </v-stepper-content>

      <v-stepper-step :editable="editableStep(6)" :step="6">
        Confirmação
      </v-stepper-step>
      <v-stepper-content step="6">
        <resume-step
            @create-application="createApplication"/>
      </v-stepper-content>

    </v-stepper>
  </in-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isEmpty, map } from 'lodash';
import InLayout from '@/layouts/InLayout';

import EntityStep from './step/EntityStep';
import MailingAddress from './step/MailingAddress';
import FrameworkStep from './step/FrameworkStep';
import ApplicationTypeStep from './step/ApplicationTypeStep';
import ResumeStep from './step/ResumeStep';

import ApplicationService from '@/services/applications/ApplicationService';
import ApplicationWay from "@/components/application/new/step/ApplicationWay.vue";

export default {
  name: 'NewApplication',
  components: {
    ApplicationWay,
    InLayout,
    EntityStep,
    MailingAddress,
    FrameworkStep,
    ApplicationTypeStep,
    ResumeStep,
  },
  mounted() {
    this.$store.dispatch('getCurrentUser');
  },
  methods: {
    ...mapActions('newApplication', ['setStep']),
    createApplication() {
      this.$store.dispatch('setLoadingDialog', true);

      const { entity, frameworkEntity, applicationType, environmentalStudyTypeRequired, applicationSimplified } = this.newApplication;
      let { applicationAddress, mailingAddress } = this.newApplication;

      const enquadramento = isEmpty(entity.enquadramento) ? null : entity.enquadramento;

      applicationAddress = {...applicationAddress, city_id: applicationAddress.city.id, federal_unit_id: applicationAddress.federal_unit.id};
      mailingAddress = {...mailingAddress, city_id: mailingAddress.city.id, federal_unit_id: mailingAddress.federal_unit.id};

      const technicalParameters = map(frameworkEntity.technicalParametersFilled, (item) => {
        return { technical_parameter_value: item.value, technical_parameter_id: item.id }
      });

      const environmentalStudyType = isEmpty(environmentalStudyTypeRequired) ? null : environmentalStudyTypeRequired; /*eslint-disable-line*/
      const analysisTypeId = isEmpty(environmentalStudyType) ? null : environmentalStudyType.analysis_type_id; /*eslint-disable-line*/

      const environmentalStudyTypeId = isEmpty(environmentalStudyType) ? null : environmentalStudyType.id; /*eslint-disable-line*/

      const applicationParams = {
        person_id: entity.id,
        enquadramento: enquadramento,
        address_attributes: applicationAddress,
        responsible_name: mailingAddress.responsible_name,
        cellphone: mailingAddress.cellphone,

        mailing_address_attributes: mailingAddress,

        typology_id: frameworkEntity.typology.id,
        application_technical_parameters_attributes: technicalParameters,
        degrading_potential_for_tax_id: frameworkEntity.degradingPotentialForTax.id,
        size_for_tax_id: frameworkEntity.sizeForTax.id,

        application_type_id: applicationType.applicationTypeSelected.id,
        subject: applicationType.subject,
        analysis_type_id: analysisTypeId,
        enviromental_study_type_id: environmentalStudyTypeId,
        is_social_interest: applicationType.isSocialInterest,
        is_process_reanalysis: applicationType.isProcessReanalysis,
        is_ownership_change: applicationType.isOwnershipChange,
        is_lac: applicationType.applicationTypeSelected.acronym === 'LAC',
        qualify_for_lac: applicationSimplified.qualify && frameworkEntity.qualifySimplifiedTechnicalParameters,
        qualification_form: applicationSimplified.simplified ? applicationSimplified.qualificacao : null
    };

      ApplicationService.createApplication(applicationParams)
        .then((response) => {
          this.$swal({
            title: 'Requerimento gerado com sucesso',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            this.$router.push(`${ response.data.id }/visualizar`);
            this.dialog = false;
          });
        })
        .catch((error) => {
          console.log(error.response.data);
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    editableStep(step) {
      return this.validSteps[step-1] || this.validSteps[step-2];
    }
  },
  computed: {
    ...mapGetters('newApplication', ['step', 'validSteps', 'newApplication']),
    stepValue: {
      get(){
        return this.step
      },
      set(newStep){
        this.setStep(newStep)
      }
    }
  }
};
</script>
